import { useSyncExternalStore } from "react";
import { TProfile, TUser, TRequest, TPharmacyProduct } from "@shared/entities";

let listeners: any[] = [];

export type CartItem = {
	product: TPharmacyProduct;
	quantity: number;
};

const storeApi = {
	async setUser(newUser: TUser | null) {
		store = { ...store, user: newUser };
		emitChange();

		return newUser;
	},
	setProfile(profile: TProfile | null) {
		store = { ...store, profile: profile };
		emitChange();
	},
	setActiveRequests(activeRequests: TRequest[]) {
		store = { ...store, activeRequests };
		emitChange();
	},
	addToCart(product: TPharmacyProduct, quantity: number = 1) {
		const existingItem = store.cart.find((item) => item.product.id === product.id);
		if (existingItem) {
			store = {
				...store,
				cart: store.cart.map((item) =>
					item.product.id === product.id
						? { ...item, quantity: item.quantity + quantity }
						: item
				),
			};
		} else {
			store = { ...store, cart: [...store.cart, { product, quantity }] };
		}
		emitChange();
	},
	removeFromCart(productId: string) {
		store = { ...store, cart: store.cart.filter((item) => item.product.id !== productId) };
		emitChange();
	},
	updateCartQuantity(productId: string, quantity: number) {
		if (quantity <= 0) {
			storeApi.removeFromCart(productId);
			return;
		}
		store = {
			...store,
			cart: store.cart.map((item) =>
				item.product.id === productId ? { ...item, quantity } : item
			),
		};
		emitChange();
	},
	clearCart() {
		store = { ...store, cart: [] };
		emitChange();
	},
	getCartTotal() {
		return store.cart.reduce((total, item) => {
			const price = item.product.discountPrice || item.product.price;
			return total + price * item.quantity;
		}, 0);
	},
	getCartItemCount() {
		return store.cart.reduce((total, item) => total + item.quantity, 0);
	},
};

// state
type Store = {
	user: TUser | null;
	profile: TProfile | null;
	activeRequests: TRequest[];
	cart: CartItem[];
	storeApi: typeof storeApi;
};

export let store: Store = {
	user: null,
	profile: null,
	activeRequests: [],
	cart: [],
	storeApi,
};

function emitChange() {
	for (const listener of listeners) {
		listener();
	}
}

function subscribe(listener: any) {
	listeners = [...listeners, listener];
	return () => {
		listeners = listeners.filter((l) => l !== listener);
	};
}
function getSnapshot() {
	return store;
}

export const useStore = () => useSyncExternalStore(subscribe, getSnapshot, () => store);
